import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { useOktaAuthContext } from '../contexts/OktaAuthContext.tsx';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const { login } = useOktaAuthContext();
  const { authState } = useOktaAuth();
  const navigate = useNavigate();

  // Redirection automatique si déjà authentifié
  useEffect(() => {
    if (authState?.isAuthenticated) {
      navigate('/projects', { replace: true });
    }
  }, [authState?.isAuthenticated, navigate]);

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
    }
  };

  // Affichage de chargement pendant la vérification
  if (authState?.isPending) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h5">Vérification de l'authentification...</Typography>
        </Box>
      </Container>
    );
  }

  // Si déjà authentifié, ne rien afficher (redirection en cours)
  if (authState?.isAuthenticated) {
    return null;
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
          <Typography component="h1" variant="h4" gutterBottom>
            Connexion
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Connectez-vous à votre compte pour accéder à l'application Soiling Mitigation
          </Typography>
          <Button variant="contained" size="large" onClick={handleLogin} sx={{ mt: 2 }}>
            Se connecter avec Okta
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;
